import React from 'react';
import SubscribedComponent from '../components/subscribed_component.js';
import BuyVideo from '../components/buy_video.js';

class BuyPremium extends SubscribedComponent {
  state = {permissions: [], subscriptionExpirations: {}, claims: {} }

  render() {
    const LayoutWrapper = this.props.layout
    const paymentLink = process.env.REACT_APP_STRIPE_PAYMENT_LINK

    return (
      <LayoutWrapper>
        <div className="page">
          <h2>Buy WreckFinder</h2>
          <hr />
          <p>Join WreckFinder premium today for &pound;19.99 per year</p>
          <p>Click the subscribe now button below and you can pay securely (Payments are securely processed by Stripe)</p>
          <p>You can cancel your subscription at any time</p>
          <a href={paymentLink} class="btn btn-lg btn-secondary">Subscribe Now!</a>
          <hr className="mt-5" />
          <p>
            Want to learn more about what wreckfinder premium includes? Checkout the following video.
          </p>
          <p>
            Please Note: This video was recorded on the iOS app.
            The Android app is slightly different in the way it works, but you do get access to all the main features, checkout all the features below:
          </p>
          <BuyVideo />
          <div className="whats-included">
            <hr />
            <h4>What’s included in Wreckfinder Premium?</h4>
            <p>Just in case you didn’t know what your membership includes, here is an overview:</p>
            <ul>
              <li>
                Full access to ALL 20,000+ wrecks and their latitude/longitude GPS coordinates
              </li>
              <li>
                View accurate distance away from any wreck in Miles/Feet or Kilometres/Metres
              </li>
              <li>
                View all the latest government posted updates about the wrecks<br />
              <img src="http://www.wreckfinder.co.uk/wp-content/uploads/2017/07/08794B2B-CC71-4F6F-A83E-A7F1AC39CFFB-169x300.png" alt="latest government updates"/>
              </li>
              <li>
                See your current location on the map as a blue dot and how far away you are from wrecks<br />
              <img src="http://www.wreckfinder.co.uk/wp-content/uploads/2017/07/BE5C97B9-34EB-4376-BAFE-E46DDA702BB3-169x300.png" alt="see your current location"/>
              </li>
              <li>
                Add favourites for quick reference to your favourite wreck locations<br />
              <img src="http://www.wreckfinder.co.uk/wp-content/uploads/2017/07/9CC4645C-8CAB-4BE7-87ED-ACB0B6B5A4C4-169x300.png" alt="add favourites"/>
              </li>
              <li>
                Login to your full account from other devices<br />
              <img src="http://www.wreckfinder.co.uk/wp-content/uploads/2017/07/6331AC21-613E-4C94-99B0-430365F96CB7-169x300.png" alt="login to you account on other devices"/>
              </li>
            </ul>
            <p>If you wish to contact me please email me via <a href="https://wreckfinder.zendesk.com/hc/en-us">our support page</a>.</p>
            <p>
              All the best,<br />
              Sean Nuzum
            </p>
            <p>
              <img src="http://www.wreckfinder.co.uk/wp-content/uploads/2017/07/sean-mug-shot-300x300.jpg" alt="Sean Nuzum"/>
            </p>
          </div>
        </div>
      </LayoutWrapper>
    )
  }
}

export default BuyPremium;



// WEBPACK FOOTER //
// ./src/pages/buy_premium.js